const publicRoutes = [
  {
    path: '/instrucao-atendente',
    name: 'attendant-instruction',
    component: () => import('@/views/AttendantInstruction.view.vue'),
    meta: {
      publicRoute: true,
      disabledPageReloadGuard: true,
      header: {
        hidePreviousBtn: true,
      },
    },
  },
];

export default publicRoutes;
